<template>
  <div id="sample-schedules">
    <h3>Sample Schedules</h3>
    <p>
      This is a list of sample schedules for your water system. The monitoring period shows the full compliance timeframe.
      You must take the number of samples indicated by <b>Samples Required</b> by the monitoring period end date. A
      schedule row will be <span class="bg-warning">highlighted yellow</span> if it is within 3 months of the monitoring
      period end date and <b>Samples Taken</b> is less than <b>Samples Required</b>
      or <span class="bg-success">highlighted green</span> if completed.
    </p>
    <p>
      <b>Note:</b> When a seasonal range is shown (with icons 🌸 Spring, ☀️ Summer, 🍂 Fall, ❄️ Winter), samples must be 
      collected during those specific months within the monitoring period.
    </p>
    <p>
      Samples must complete a thorough laboratory authorization process before results are released, which can take
      several weeks from the initial receipt date.
    </p>
    <b-table :responsive="true" striped hover :items="sample_schedules" :fields="table_fields"
      :tbody-tr-class="rowClass">
      <template #cell(monitoring_period)="data">
        <div>
          <div class="font-weight-bold">{{ data.item.mprd_name }}</div>
          <div class="small text-muted" v-if="data.item.cp_prd_begin_dt">
            <b>Begin:</b> {{ formatDate(data.item.cp_prd_begin_dt) }}
          </div>
          <div class="small text-muted" v-if="data.item.cp_prd_end_dt">
            <b>End:</b> {{ formatDate(data.item.cp_prd_end_dt) }}
          </div>
        </div>
      </template>
      <template #cell(seasonal)="data">
        <span class="text-nowrap" v-if="data.item.begin_month && data.item.begin_day && data.item.end_month && data.item.end_day">
          {{ getSeasonIcon(data.item.begin_month) }}
          {{ formatSeasonalRange(data.item) }}
        </span>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: "SampleSchedules",
  data() {
    return {
      sample_schedules: [],
      table_fields: [
        { key: "schedule_name", label: "Schedule Name", formatter: this.formatScheduleName },
        { key: "facility_info", label: "Facility" },
        { key: "sub_smppt_info", label: "Subschedule Sampling Point" },
        { key: "samples_required", label: "Samples Required" },
        { key: "samples_taken", label: "Samples Taken" },
        { key: "monitoring_period", label: "Monitoring Period" },
        { key: "seasonal", label: "Seasonal" },
      ]
    }
  },
  computed: {
    pws_id: function () {
      return this.$store.state.pws_id
    },
  },
  created() {
    console.log("created")
    this.fetchSchedules()
  },
  mounted() {
    console.log("mounted")
    this.app_mounted = true
  },
  methods: {
    formatDate(dtstr) {
      if (dtstr) {
        // Parse YYYY-MM-DD manually to avoid timezone issues
        const [year, month, day] = dtstr.split('-')
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        return `${monthNames[month - 1]} ${parseInt(day)}, ${year}`
      } else {
        return ""
      }
    },
    getSeasonIcon(month) {
      if (month >= 3 && month <= 5) {
        return '🌸' // Spring (March-May)
      } else if (month >= 6 && month <= 8) {
        return '☀️' // Summer (June-August)
      } else if (month >= 9 && month <= 11) {
        return '🍂' // Fall (September-November)
      } else {
        return '❄️' // Winter (December-February)
      }
    },
    formatSeasonalRange(item) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                         'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      if (item.begin_month && item.begin_day && item.end_month && item.end_day) {
        const beginStr = `${monthNames[item.begin_month - 1]} ${item.begin_day}`
        const endStr = `${monthNames[item.end_month - 1]} ${item.end_day}`
        return `${beginStr} - ${endStr}`
      }
      return ''
    },
    formatScheduleName(sched_name) {
      // strip
      sched_name = sched_name.trim()
      const names = {
        'TTHM/HAA5': 'TTHM/HAA5 (DBP)',
        'NO2-NO3': 'NITRATES'
      }
      return names[sched_name] || sched_name
    },
    rowClass(item) {
      // date 3 months in the future
      const future = new Date()
      future.setMonth(future.getMonth() + 3)
      if (item.cp_prd_end_dt && new Date(item.cp_prd_end_dt) < future && item.samples_taken < item.samples_required) {
        return "table-warning"
      } else if (item.samples_taken >= item.samples_required) {
        return "table-success"
      } else {
        return ""
      }
    },
    fetchSchedules() {
      console.log("called schedules")
      const path = process.env.VUE_APP_API_URI + "/pws-sample-schedules"
      return this.axios
        .get(path, { params: { pws_id: this.$store.state.pws_id } })
        .then((res) => {
          if (res.data.sample_schedules) {
            for (const schedule of res.data.sample_schedules) {
              if (schedule.analyte_name) {
                schedule.schedule_name = schedule.analyte_name
              } else {
                schedule.schedule_name = schedule.analyte_group
              }
              if (schedule.facility_local_name.length > 0) {
                schedule.facility_info = schedule.facility_id + " - " + schedule.facility_local_name
              } else {
                schedule.facility_info = schedule.facility_id
              }
              // subschedule
              if (schedule.sub_smppt_id) {
                if (schedule.sub_smppt_desc) {
                  schedule.sub_smppt_info = schedule.sub_smppt_id + " - " + schedule.sub_smppt_desc
                } else {
                  schedule.sub_smppt_info = schedule.sub_smppt_id
                }
              }
              this.sample_schedules.push(schedule)
            }
          } else {
            console.log("sample schedule data fetch failed")
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
  }
}

</script>
